/**
 * Single-sign-on identity-provider configuration. Reads and edits the SSO/IdP
 * bindings for one user (`auth/user-idps`) and one customer
 * (`auth/customer-idps`).
 *
 * Contains:
 * - fetchUserIdps / editUserIdp: a user's identity providers
 * - fetchCustomerIdps / editCustomerIdp: a customer's identity providers
 */
import apiClient from '@sophocles/http-common';

export const fetchUserIdps = userId => apiClient.get(`auth/user-idps/${userId}`).then(res => res.data?.idps ?? []);

export const editUserIdp = (userId, idpId, data) =>
  apiClient.put(`auth/user-idps/${userId}/${idpId}`, data).then(res => res.data);

export const fetchCustomerIdps = customerId =>
  apiClient.get(`auth/customer-idps/${customerId}`).then(res => res.data?.idps ?? []);

export const editCustomerIdp = (customerId, idpId, data) =>
  apiClient.put(`auth/customer-idps/${customerId}/${idpId}`, data).then(res => res.data);
